<template>
  <div class="base-basic">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <div class="nav-title">项目组信息</div>
    </div>

    <!-- 内容区域 -->
    <div class="body-content">
      <div class="info-card">
        <div class="info-item">
          <span class="info-label">平台技术支持：</span>
          <span class="info-value">解方程医疗科技（杭州）有限公司</span>
        </div>
        <div class="info-item">
          <span class="info-label">联系人：</span>
          <span class="info-value">周瑶</span>
        </div>
        <div class="info-item">
          <span class="info-label">手机号：</span>
          <span class="info-value">19858117885</span>
        </div>
        <div class="info-item">
          <span class="info-label">邮箱：</span>
          <span class="info-value">19858117885@163.com</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from 'vant';

export default {
  name: 'ProjectInfo',
  components: {
    VanIcon: Icon
  },
  methods: {
    goBack() {
      this.$router.back();
    }
  }
};
</script>

<style scoped>
.base-basic {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

/* 顶部导航栏 */
.top-nav {
  display: flex;
  align-items: center;
  height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  padding: 0 15px;
  position: relative;
}

.back-icon {
  font-size: 20px;
  color: #333;
}

.nav-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

/* 内容区域 */
.body-content {
  flex: 1;
  padding: 20px 15px;
  overflow-y: auto;
}

/* 信息卡片 */
.info-card {
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* 信息项 */
.info-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.info-item:last-child {
  margin-bottom: 0;
}

/* 信息标签 */
.info-label {
  font-size: 15px;
  color: #666;
  width: 120px;
}

/* 信息值 */
.info-value {
  font-size: 15px;
  color: #333;
  flex: 1;
}
</style>